import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// key 对应主站语言简写  value 对应文件名称
export const enumLang = {
  en: "year_report_en",
  zh: "year_report_zh",
  tw: "year_report_tw",
  br: "year_report_br",
  de: "year_report_de",
  es: "year_report_es",
  fr: "year_report_fr",
  id: "year_report_id",
  it: "year_report_it",
  ja: "year_report_ja",
  nl: "year_report_nl",
  pt: "year_report_pt",
  ru: "year_report_ru",
  th: "year_report_th",
  tr: "year_report_tr",
  uk: "year_report_uk",
  vn: "year_report_vn",
  ar: "year_report_ar",
};

const resources = {};
const getFile = (filename) => require(`./${filename}.json`);

Object.keys(enumLang).forEach((key) => {
  resources[key] = {
    translation: getFile(enumLang[key]),
  };
});
i18next.use(initReactI18next).init({
  resources,
  lng: "cn",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
